import { Button } from "components";

interface PageProps {
  number: number;
  active: boolean;
  onClick(page: number): void;
}

const Page: React.FC<PageProps> = ({ number, active, onClick }) => {
  const style = {
    minWidth: "unset",
    width: "32px",
    height: "32px",
    padding: 0,
  };

  return (
    <Button
      size="small"
      onClick={() => onClick(number)}
      active={active}
      color={active ? "#1565c0" : "#757575"}
      style={style}
    >
      {number}
    </Button>
  );
};

export default Page;
